import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    VDAStatusApi, setSelectedZone, restoreValue, TempChange
} from '../../action/roomControlAction'
import { cmsColorConfig } from '../../JS/setColors'
import zoneItemImage from '../../images/link-icons/ico_temp.svg'

class SelectZoneScreen extends Component {

    componentDidMount(prePro) {
        let sessionToken = localStorage.getItem("GuestJourneySessionToken")
        cmsColorConfig(this.props.menuColor);
        if (sessionToken && this.props.guestDetail.locationId && this.props.guestDetail.guestToken) {
            this.props.VDAStatusApi(
                sessionToken, this.props.guestDetail,
                this.VDAStatusCallBack, null
            );
        }
    }
    VDAStatusCallBack = () => {

    }
    selectZone = (selectedZone, indexOfSelectedZone) => {
        console.log("selectedZone", selectedZone)
        if (selectedZone.zoneId) {
            let temp = parseInt(selectedZone.hvac.temperatureValue.slice(2, 4));
            let roomTemp = parseInt(selectedZone.hvac.currentRoomTemperature.slice(2, 4));
            this.props.setSelectedZone(selectedZone, roomTemp, indexOfSelectedZone);
            this.props.TempChange(null, temp);
        }
    }

    render() {
        return (
            <div
                id="ac-selection"
                class="tiles"
                style={this.props.selectedZone.zoneId ? { display: "none" } : {}}>
                <p><strong></strong></p>
                <ul class="tile-links" data-parent="ac-selection">
                    {
                        this.props.VDAZoneList.map((iterator, index) => {
                            if (iterator.hvac && iterator.hvac.temperatureValue) {
                                return (
                                    <li >
                                        <button className="button"
                                            data-target="temp-selection" onClick={() => { this.selectZone(iterator, index) }}>
                                            <img src={zoneItemImage} />
                                            {iterator.hvac.label}
                                        </button>
                                    </li>
                                )
                            }
                        })
                    }
                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        selectedZone: state.store.roomControl.selectedZone,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        seletedIndex: state.store.roomControl.seletedIndex
    }
}

export default connect(
    mapStateToProps,
    {
        VDAStatusApi,
        setSelectedZone,
        restoreValue,
        TempChange
    }
)(SelectZoneScreen);